export const NAV_OFFSET_PX = 80;

export function scrollToId(id: string): void {
  const el = document.getElementById(id);
  if (!el) return;

  const top = el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET_PX;
  window.scrollTo({ top, behavior: 'smooth' });
}

